import { ColumnMetadata, ColumnTypes } from "~/components/DataGrid";
import { AssetColumns } from "~/modules/assets/types";
import { Emdash } from "~/components/Punctuation";
import { DataGridDollarPercentChangeComboCell } from "~/components/DataGrid/DataGridDollarPercentChangeComboCell";
import { getMeasureValue } from "~/utils/getMeasureValue";
import { AssetTableRowData } from "../types";
import { CatalogMetricSlugs } from "~/modules/catalog/types";

// // // //

export const TOTAL_ASSET_VALUE_COLUMN: ColumnMetadata<
    AssetTableRowData,
    AssetColumns
> = {
    slug: AssetColumns.totalAssetValueDollar,
    label: "Total Value",
    tooltip: CatalogMetricSlugs.total_asset_value_dollar,
    type: ColumnTypes.dollar,
    sortsOn: AssetColumns.totalAssetValueDollar,
    width: 175,
    render: (item) => {
        const measure = getMeasureValue(item, "total_asset_value_dollar");

        if (measure === null) {
            return <Emdash />;
        }

        return (
            <DataGridDollarPercentChangeComboCell
                value={measure.val}
                pct_change_interval="7d"
                pct_change_value={measure.chg_7d_pct}
            />
        );
    },
};
